import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
    template: ''
})
export class AbstractViewComponent implements OnDestroy {
    protected ngUnsubscribe: Subject<any> = new Subject();

    ngOnDestroy(): void {
        this.ngUnsubscribe.next('');
        this.ngUnsubscribe.complete();
    }
}
